import React from 'react';
import { useIntl } from 'react-intl';

import { Chip } from '~/eds/src/components/Chip/Chip';
import {
  EsignatureEnvelope,
  EsignatureEnvelopeStatusValue,
} from '~/features/ticket/types/esignature';

interface EnvelopeStatusChipProps {
  envelope: EsignatureEnvelope;
  isLoading?: boolean;
}

type ChipStatus = 'warning' | 'success' | 'danger' | 'info';

const getEnvelopeStatusColor = (
  statusValue: EsignatureEnvelopeStatusValue,
): ChipStatus => {
  const statusMap: Record<EsignatureEnvelopeStatusValue, ChipStatus> = {
    created: 'warning',
    sent: 'warning',
    signed: 'success',
    declined: 'danger',
    voided: 'danger',
    error: 'danger',
  };
  return statusMap[statusValue] || 'info';
};

export const EnvelopeStatusChip = ({
  envelope,
  isLoading,
}: EnvelopeStatusChipProps) => {
  const intl = useIntl();

  if (isLoading) {
    return (
      <Chip
        preset="loading"
        text={intl.formatMessage({
          id: 'EnvelopeStatusChip.loadingMessage',
          defaultMessage: 'Loading...',
          description: 'Loading message for envelope status',
        })}
      />
    );
  }

  if (!envelope?.status) {
    return null;
  }

  return (
    <Chip
      status={getEnvelopeStatusColor(envelope.status.value)}
      text={envelope.status.label}
    />
  );
};
